import _extends from "@babel/runtime/helpers/extends";
import { Button } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { useIsDesktopDimension } from '@beef/ui-kit';
import { IconChevronLeft } from '@carnica/graphics';
import { findFirst } from "../../../../utils/arrays";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var BackButton = function BackButton(props) {
  var isDesktop = useIsDesktopDimension();
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    className: cn('button', {
      'is-white': props.isWhite
    }, props.className),
    iconLeft: IconChevronLeft,
    onlyIcon: true,
    size: "m",
    view: findFirst([!props.isWhite && isDesktop && 'secondary-invert', 'secondary']),
    "data-t-id": "HeaderButtons-BackButton"
  }));
};